import type { EmployeeAlertAgeOutOfRange } from '@/common/graphql';
import { FormattedDate } from '../FormattedDate';

export const DetailDescriptionEmployeeAlertAgeOutOfRange = ({
  reason,
}: {
  reason: Pick<EmployeeAlertAgeOutOfRange, 'dateOfBirth' | 'age' | 'priority' | 'summary'>;
}) => (
  <>
    <div>
      Age:&nbsp;
      {reason.age} years old
    </div>
    <div>
      <FormattedDate prefix="Date of birth" date={reason.dateOfBirth} />
    </div>
  </>
);
